import React, { useEffect, useState } from 'react'
import { useRouteMatch } from 'react-router-dom'
import classNames from 'classnames'
import { generateOrderHeader, generateOrderRow } from '../../utils/strategies.util'
import { round } from '../../utils/calc.util'

function TestingAccount({ strategies }) {
  const match = useRouteMatch()
  const [selectedAccount, setSelectedAccount] = useState({})
  const [positiveClosedOrdersCount, setPositiveClosedOrdersCount] = useState(0)
  const [negativeClosedOrdersCount, setNegativeClosedOrdersCount] = useState(0)
  const [positiveNegativeRatio, setPositiveNegativeRatio] = useState(0)

  const activeStrategy = strategies?.find(strategy => strategy.name === match.params.strategyName)

  useEffect(() => {
    const activeAccount = activeStrategy?.accounts?.find(account => account.name === match.params.accountName)

    if (activeAccount) {
      const closedOrders = activeAccount?.spot?.closedOrders?.reduce((acc, order) => {
        const isLongOrder = order.type === 'SELL'
        const isSuccessfulOrder = isLongOrder ? order.sellingPrice > order.buyingPrice : order.sellingPrice < order.buyingPrice
        isSuccessfulOrder ? acc[0]++ : acc[1]++
        return acc
      }, [0, 0])
      const positiveClosedOrdersLength = closedOrders[0]
      const negativeClosedOrdersLength = closedOrders[1]

      if (closedOrders) {
        setPositiveClosedOrdersCount(positiveClosedOrdersLength || 0)
        setNegativeClosedOrdersCount(negativeClosedOrdersLength || 0)
        setPositiveNegativeRatio(round(positiveClosedOrdersLength * 100 / (positiveClosedOrdersLength + negativeClosedOrdersLength), 0) || 0)
      }
    }

    setSelectedAccount(activeAccount)
  }, [strategies, match.params.accountName, match.params.strategyName])

  return (
    <div className="cards">
      <div className="card card-half-width">
        <div className="card-header">
          <div className="card-row card-row-header">
            <div className="card-cell">
              Closed orders |&nbsp;
              <span className="card-cell-success">{positiveClosedOrdersCount || 0}</span>&nbsp;/&nbsp;
              <span className="card-cell-danger">{negativeClosedOrdersCount || 0}</span>&nbsp;/&nbsp;
              <span className={positiveNegativeRatio > 60 ? 'card-cell-success' : 'card-cell-danger'}>
                {positiveNegativeRatio}%
              </span>
            </div>

          </div>
        </div>
        <div className="card-content">
          <div className="card-row card-row-header">
            {generateOrderHeader().map(tableCell => (
              <div key={tableCell.label} className={tableCell.className}>{tableCell.label}</div>
            ))}
          </div>
          {selectedAccount?.spot?.closedOrders?.map((order, index) => {
            const orderRowClassnames = classNames(
              'card-row',
              order.type === 'SELL' ?
                (order.sellingPrice > order.buyingPrice ? 'card-row-success' : 'card-row-danger') :
                (order.sellingPrice < order.buyingPrice ? 'card-row-success' : 'card-row-danger')
            )

            return (
              <div key={index} className={orderRowClassnames}>
                {generateOrderRow(order, activeStrategy, selectedAccount).map((bodyCell, index) => (
                  <div key={String(bodyCell.value) + index}
                    className={bodyCell.className}
                    onClick={bodyCell.onClick}
                  >{bodyCell.value}</div>
                ))}
              </div>
            )
          })}
        </div>
      </div>

      <div className="card card-half-width">
        <div className="card-header">
          <div className="card-row card-row-header">
            <div className="card-cell">
              Open orders
            </div>
          </div>
        </div>
        <div className="card-content">
          <div className="card-row card-row-header">
            {generateOrderHeader().map(tableCell => (
              <div key={tableCell.label} className={tableCell.className}>{tableCell.label}</div>
            ))}
          </div>
          {selectedAccount?.spot?.openOrders?.map((order, index) => {
            const orderRowClassnames = classNames(
              'card-row',
              order.type === 'SELL' ?
                (order.sellingPrice > order.buyingPrice ? 'card-row-success' : 'card-row-danger') :
                (order.sellingPrice < order.buyingPrice ? 'card-row-success' : 'card-row-danger')
            )

            return (
              <div key={index} className={orderRowClassnames}>
                {generateOrderRow(order, activeStrategy, selectedAccount).map((bodyCell, index) => (
                  <div key={bodyCell.value + index}
                    className={bodyCell.className}
                    onClick={bodyCell.onClick}
                  >{bodyCell.value}</div>
                ))}
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default TestingAccount
